import React, { useState, useEffect } from 'react';
import DocumentCard from '../components/DocumentCard';
import { grade9Documents } from '../data/dummyData';
import './GradePage.css';

const Grade9Page = () => {
  const [documents, setDocuments] = useState([]);
  const [filteredDocs, setFilteredDocs] = useState([]);
  const [selectedYear, setSelectedYear] = useState('All');
  const [selectedSubject, setSelectedSubject] = useState('All');

  useEffect(() => {
    // Load documents
    setDocuments(grade9Documents);
    setFilteredDocs(grade9Documents);
  }, []);

  useEffect(() => {
    // Filter documents based on selections
    let filtered = documents;
    
    if (selectedYear !== 'All') {
      filtered = filtered.filter(doc => doc.year === selectedYear);
    }
    
    if (selectedSubject !== 'All') {
      filtered = filtered.filter(doc => doc.subject === selectedSubject);
    }
    
    setFilteredDocs(filtered);
  }, [selectedYear, selectedSubject, documents]);

  const handleDownload = (docId) => {
    console.log(`Document ${docId} downloaded`);
  };

  // Get unique years and subjects for filters
  const years = ['All', ...new Set(documents.map(doc => doc.year))];
  const subjects = ['All', ...new Set(documents.map(doc => doc.subject))];

  const handleClearFilters = () => {
    setSelectedYear('All');
    setSelectedSubject('All');
  };

  return (
    <div className="grade-page">
      <div className="container">
        {/* Filters Section */}
        <div className="filters-section">
          <div className="filters-header">
            <h2>KPSEA Past Papers & Resources</h2>
            <p>Download past papers and study materials for Grade 9</p>
          </div>
          
          <div className="filters-grid">
            {/* Year Filter */}
            <div className="filter-group">
              <label htmlFor="year-filter" className="filter-label">Year</label>
              <select
                id="year-filter"
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className="filter-select"
              >
                {years.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>
            
            {/* Subject Filter */}
            <div className="filter-group">
              <label htmlFor="subject-filter" className="filter-label">Subject</label>
              <select
                id="subject-filter"
                value={selectedSubject}
                onChange={(e) => setSelectedSubject(e.target.value)}
                className="filter-select"
              >
                {subjects.map(subject => (
                  <option key={subject} value={subject}>{subject}</option>
                ))}
              </select>
            </div>
          </div>
          
          {/* Results Count and Clear Button */}
          <div className="results-info">
            <span className="results-count">
              Showing {filteredDocs.length} of {documents.length} documents
            </span>
            {(selectedYear !== 'All' || selectedSubject !== 'All') && (
              <button 
                className="clear-filters"
                onClick={handleClearFilters}
              >
                Clear filters
              </button>
            )}
          </div>
        </div>
        
        {/* Documents Grid */}
        {filteredDocs.length > 0 ? (
          <div className="documents-grid">
            {filteredDocs.map(doc => (
              <DocumentCard
                key={doc.id}
                document={doc}
                onDownload={handleDownload}
              />
            ))}
          </div>
        ) : (
          <div className="no-results">
            <div className="no-results-icon">📚</div>
            <h3>No documents found</h3>
            <p>Try changing your filters</p>
            <button 
              className="clear-filters-btn"
              onClick={handleClearFilters}
            >
              Clear all filters
            </button>
          </div>
        )}
        
        {/* Additional Resources Section */}
        <section className="additional-resources">
          <h2>Additional Learning Resources</h2>
          <div className="resources-list">
            <div className="resource-item">
              <h3>Study Guides</h3>
              <p>Comprehensive study guides for all subjects</p>
            </div>
            <div className="resource-item">
              <h3>Revision Questions</h3>
              <p>Practice questions with answers</p>
            </div>
            <div className="resource-item">
              <h3>Teaching Materials</h3>
              <p>Resources for teachers and parents</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
export default Grade9Page;